angular.module('zc')
  .component('zcIwUseRate', {
    templateUrl: '/templates/projects.iw/iw_use_rate.html',
    bindings: {
      project: '<',
      filters: '<'
    },
    controller: zcIwUseRateController
  });

zcIwUseRateController.$inject = ['$scope', '$filter', '$window', 'InterestWidgetStats', 'ChartV2', 'lineChartV2Config', 'lib'];
function zcIwUseRateController($scope, $filter, $window, InterestWidgetStats, ChartV2, lineChartV2Config, lib) {
  const vm = this;

  const chart = new ChartV2(lineChartV2Config, {
    yAxis: [{
      title: { text: null },
      min: 0,
      labels: {
        formatter: function() { return `${$window.Highcharts.numberFormat(this.value, 0)} ${$filter('translate')('sharedModules.common.unit.session')}` }
      },
    }, {
      opposite: true,
      title: { text: null },
      min: 0,
      labels: {
        formatter: function() { return `${$window.Highcharts.numberFormat(this.value, 2)} %` }
      }
    }]
  });
  vm.chartConfig = chart.getConfig();

  vm.$onInit = () => {
    updateData();
    $scope.$on('filtersUpdated', updateData);
  };

  function updateData() {
    InterestWidgetStats.findByFilters(vm.project.apikey, vm.filters)
      .then(stats => {
        vm.total = InterestWidgetStats.transform(lib.sumCountMap(stats));
        const iwUseStats = [];
        const iwUseRateStats = [];
        stats.forEach(stat => {
          stat = InterestWidgetStats.transform(stat);
          iwUseStats.push([stat.start_at.valueOf(), stat.iw_use.session_count]);
          iwUseRateStats.push([stat.start_at.valueOf(), stat.iw_use_rate]);
        });
        chart.resetSeries();
        chart.addSeries({
          type: 'column',
          name: $filter('translate')('projectsIw.useRate.deliverySessionCount'),
          data: iwUseStats,
          tooltip: {
            valueSuffix: $filter('translate')('projectsIw.useRate.deliverySessionCount'),
            valueDecimals: 0
          },
          yAxis: 0
        });
        chart.addSeries({
          type: 'line',
          name: $filter('translate')('projectsIw.useRate.deliverySessionCount'),
          data: iwUseRateStats,
          tooltip: {
            valueSuffix: '%',
            valueDecimals: 1
          },
          yAxis: 1
        });
      });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.iw/iw_use_rate.js